module.exports = __webpack_public_path__ + "static/media/photomaraphon.1b24f3d2.jpg";